import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Package, ShoppingBag, AlertTriangle } from "lucide-react";
import { adminProductsQuery, adminOrdersQuery } from "@/lib/admin/admin.functions";
import { adminFailedTinySyncProductsQuery } from "@/lib/admin/erp.functions";

export const Route = createFileRoute("/admin/")({
  component: AdminDashboard,
});

function AdminDashboard() {
  const { data: products } = useQuery(adminProductsQuery());
  const { data: orders } = useQuery(adminOrdersQuery());
  const { data: failedProducts } = useQuery(adminFailedTinySyncProductsQuery());

  const pendingOrders = orders?.filter((o) => o.status === "pending").length ?? 0;
  const orderSyncFailures = orders?.filter((o) => o.tiny_sync_failed_at).length ?? 0;
  const productSyncFailures = failedProducts?.length ?? 0;

  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-eg-dark mb-6">Dashboard</h1>
      <div className="grid gap-4 sm:grid-cols-4">
        <Link
          to="/admin/produtos"
          className="rounded-lg border border-border bg-white p-5 hover:border-eg-gold transition-colors"
        >
          <Package className="h-6 w-6 text-eg-gold mb-2" />
          <p className="text-2xl font-bold text-eg-dark">{products?.length ?? "—"}</p>
          <p className="text-sm text-muted-foreground">Produtos cadastrados</p>
        </Link>
        <Link
          to="/admin/pedidos"
          className="rounded-lg border border-border bg-white p-5 hover:border-eg-gold transition-colors"
        >
          <ShoppingBag className="h-6 w-6 text-eg-gold mb-2" />
          <p className="text-2xl font-bold text-eg-dark">{pendingOrders}</p>
          <p className="text-sm text-muted-foreground">Pedidos aguardando pagamento</p>
        </Link>
        <Link
          to="/admin/pedidos"
          className="rounded-lg border border-border bg-white p-5 hover:border-eg-gold transition-colors"
        >
          <AlertTriangle className="h-6 w-6 text-red-600 mb-2" />
          <p className="text-2xl font-bold text-eg-dark">{orderSyncFailures}</p>
          <p className="text-sm text-muted-foreground">Pedidos com falha de sync no Tiny</p>
        </Link>
        <Link
          to="/admin/produtos"
          className="rounded-lg border border-border bg-white p-5 hover:border-eg-gold transition-colors"
        >
          <AlertTriangle className="h-6 w-6 text-red-600 mb-2" />
          <p className="text-2xl font-bold text-eg-dark">{productSyncFailures}</p>
          <p className="text-sm text-muted-foreground">Produtos com falha de sync no Tiny</p>
        </Link>
      </div>
    </div>
  );
}
